import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "battery-3",
  "use": "battery-3-usage",
  "viewBox": "0 0 90 46.78",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 90 46.78\" id=\"battery-3\"><title>资源 32</title><g data-name=\"图层 2\"><g data-name=\"图层 1\"><path d=\"M7.48 7.48h42.16v31.81H7.48z\" /><path d=\"M85.7 15.53V7.86A8.11 8.11 0 0 0 77.46 0H8.23A8.11 8.11 0 0 0 0 7.86v31.25a8.08 8.08 0 0 0 8.23 7.67h69.42a8.11 8.11 0 0 0 8.23-7.86v-7.86A4 4 0 0 0 90 27.13v-7.86a4.28 4.28 0 0 0-4.3-3.74zm-4 3.93v19.46a4.08 4.08 0 0 1-4.21 3.93H8.23a4 4 0 0 1-4.12-3.93V7.86a4 4 0 0 1 4.12-3.93h69.42a3.92 3.92 0 0 1 4 3.93z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/battery-3.svg
// module id = lxX+
// module chunks = 6